import { render, staticRenderFns } from "./ListItemSort.vue?vue&type=template&id=511ba46c&scoped=true&"
import script from "./ListItemSort.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemSort.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ListItemSort.vue?vue&type=style&index=0&id=511ba46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ba46c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511ba46c')) {
      api.createRecord('511ba46c', component.options)
    } else {
      api.reload('511ba46c', component.options)
    }
    module.hot.accept("./ListItemSort.vue?vue&type=template&id=511ba46c&scoped=true&", function () {
      api.rerender('511ba46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemSort/ListItemSort.vue"
export default component.exports